module.exports = __webpack_public_path__ + "static/media/15855.0e108d6b.jpg";